import * as React from 'react'

function SvgCh(props) {
	return (
		<svg viewBox="0 0 320 320" width="1em" height="1em" {...props}>
			<path fill="#D52B1E" d="M0 0h320v320H0z" />
			<path fill="#fff" d="M60 130h200v60H60z" />
			<path fill="#fff" d="M130 60h60v200h-60z" />
		</svg>
	)
}

export default SvgCh
